import access from './access/themeLena'
import nodeTypes from './node/themeLena'
import organization from './organization/themeLena'
import roles from './roles/themeLena'
import taxonomy from './taxonomy/themeLena'
import templates from './templates/themeLena'
import tasks from './tasks/themeLena'
import users from './users/themeLena'
import vendors from './vendors/themeLena'
import userfilemanager from './userfilemanager/themeLena'
import content from './views/themeLena'
import forms from './forms/themeLena'
import notFound from './errors/themeLena'
import comments from './comments/themeLena'
import support from './support/themeLena'
import terms from './taxonomy/terms/themeLena'
import directory from './directory/themeLena'
import profile from './userProfile/themeLena'
import adminNavigation from './adminNavigation/themeLena'
import routes from './routes/themeLena'
import modules from './modules/themeLena'
import configuration from './configuration/themeLena'
import bundles from './bundles/themeLena'
import exportedFiles from './exportedFile/themeLena'
import backgroundTask from './backgroundTask/themeLena'
import eventLog from './eventlog/themeLena'
import productionCalendar from './productionCalendar/themeLena'

export const commonModules = [
  vendors,
  userfilemanager,
  roles,
  access,
  users,
  taxonomy,
  nodeTypes,
  templates,
  organization,
  content,
  forms,
  comments,
  notFound,
  support,
  terms,
  directory,
  profile,
  adminNavigation,
  routes,
  modules,
  configuration,
  bundles,
  exportedFiles,
  backgroundTask,
  eventLog,
  productionCalendar,
  tasks,
]
